import React from 'react';

export default function UserPlayIcon() {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="32" cy="20" r="10" fill="#4F46E5" />
        <path
          d="M16 50c0-8.837 7.163-16 16-16s16 7.163 16 16v4H16v-4z"
          fill="#4F46E5"
        />
        <circle cx="48" cy="48" r="12" fill="#F97316" />
        <polygon points="44,42 56,48 44,54" fill="white" />
      </svg>
    </div>
  );
}
